import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styles from "components/settings/integration-settings.scss";
import { trackPageAction } from "actions/shared/tracking-actions";

class SetUpIntegrationPage extends React.Component {
  componentWillMount() {
    this.props.trackPage();
  }

  render() {
    const iframeParams = "&showHeader=false&reauthorise=true&parent=digit";
    return (
      <div className={ styles.container }>
        <div className={ styles["iframe-container"] }>
          <iframe
            className={ styles.iframe }
            src={ `${INTEGRATIONS_PAGE_BASE_URL}accountid=${this.props.accountId}${iframeParams}` }
          />
        </div>
      </div>
    );
  }
}

SetUpIntegrationPage.propTypes = {
  accountId: PropTypes.string.isRequired,
  trackPage: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  accountId: state.app.selectedAccount.id,
  accountSlug: state.app.selectedAccount.slug,
  categories: state.categories.categories
});

const mapDispatchToProps = (dispatch) => ({
  trackPage: () => dispatch(trackPageAction("Set up integration page"))
});

export const SetUpIntegrationContainer = connect(mapStateToProps, mapDispatchToProps)(SetUpIntegrationPage);



// WEBPACK FOOTER //
// ./src/js/containers/set-up-integration-container.jsx